<template>
  <fieldUpload :required="required" :imgCenter="imgCenter" ref="img" v-if="type==='image'" v-model="innerValue" v-bind="$props">
    <slot></slot>
  </fieldUpload>
  <!--  <van-field v-else-if="type==='number'"-->
  <!--             :label="label"-->
  <!--             :placeholder="placeholder"-->
  <!--             v-model="innerValue"-->
  <!--             :formatter="formatter_number"-->
  <!--             :labelWidth="labelWidth"-->
  <!--             :rules="rulesInner"-->
  <!--             :required="required"-->
  <!--             :clearable="clearable"-->
  <!--  />-->
  <van-field v-else-if="type==='richText'"
             :label="label"
             :placeholder="placeholder"
             v-model="innerValue"
             rows="3"
             autosize
             type="textarea"
             maxlength="2000"
             show-word-limit
             :labelWidth="labelWidth"
             :rules="rulesInner"
             :required="required"
             :clearable="clearable"


  />
  <van-field v-else-if="type==='date'" class="date"
             :label="label"
             :placeholder="placeholder"
             v-model="innerValue"
             :labelWidth="labelWidth"
             :rules="rulesInner"
             :required="required"
             :clearable="clearable"
             :right-icon="(clearable && innerValue) ? 'close' : null"
             @click-right-icon="innerValue=null"
             :style="{width}"
  >
    <template #input>
      <div v-if="innerValue" style="width: 100%;height: 100%;min-height: 0.4rem;" @click="show=true">{{ innerValue }}
      </div>
      <div class="" v-else @click="show=true" style="color: #ccc">{{ placeholder }}</div>
      <!--&lt;!&ndash;        <input type="text" v-model="innerValue" @click="show=true">&ndash;&gt;-->
    </template>
    <template #extra>
      <van-popup
        v-model="show"
        close-icon-position="top-left"
        position="bottom"
      >
        <!--          title="选择年月日"-->
        <van-datetime-picker
          :min-date="minDate"
          :max-date="maxDate"
          v-model="date"
          type="date"
          @cancel="show=false"
          @confirm="innerValue=date.Format('yyyy-MM-dd');show=false"
        />
      </van-popup>
    </template>
  </van-field>
  <van-field v-else-if="type==='select'"
             :label="label"
             :placeholder="placeholder"
             :labelWidth="labelWidth"
             :rules="rulesInner"
             :required="required"
             :clearable="clearable"
             :right-icon="(clearable && innerValue) ? 'close' : null"
             @click-right-icon="innerValue=null"
  >
    <template #input>
      <input type="text" @click="showPicker=true" @focus="showPicker=true" :value="columnsLabel"
             class="van-field__control" />
    </template>
    <template #extra>
      <van-popup
        v-model="showPicker"
        close-icon-position="top-left"
        position="bottom"
      >
        <!--          showPick={{showPicker}}-->
        <!--          title="选择年月日"-->
        <van-picker
          :title="label"
          :columns="columns"
          show-toolbar
          @confirm="onConfirm"
          @cancel="(newVal,oldVal)=>$emit('cancel',newVal,oldVal)"
          @change="(newVal,oldVal)=>$emit('change',newVal,oldVal)"
        >
          <template #option="item">
            {{ columnsLabelFun(item) }}
          </template>
        </van-picker>
      </van-popup>
    </template>
  </van-field>
  <!--  ="type==='text'" 基础类型-->
  <van-field v-else
             v-bind="$props"
             v-model="innerValue"
             :rules="rulesInner"
             :style="{width}"
             @keyup.enter.native="$emit('keyup',innerValue)"
  />
</template>

<script>
import fieldUpload from "./fieldUpload.vue";

export default {
  name: "zfield",
  components: {
    fieldUpload
  },
  props: {
    slotInput: { default: false },
    imgCenter: {},
    module: {},
    type: {},
    value: {},
    label: {},
    rules: {},
    width: { type: String, default: () => "100%" },
    labelWidth: {},
    placeholder: {},
    required: {},
    readonly: {},
    disabled: {},
    clearable: {
      default: true
    },
    minDate: { default: () => new Date(2020, 0, 1) },
    maxDate: { default: () => new Date(2050, 0, 1) },
    currentDate: { default: () => new Date() },
    columns: { type: Array, default: () => [] },
    columnsKeyFun: { type: Function, default: (o) => o },
    columnsLabelFun: { type: Function, default: (o) => o },
    loading: { default: false }
  },
  data() {
    return {
      innerValue: null,
      innerValueUpload: [],
      showPicker: null,
      loadingInner: false,
      date: this.currentDate,
      show: false,
      file: null
    };
  },
  computed: {
    rulesInner() {
      let required = null !== this.required && false !== this.required;
      let pleaseInput = this.type === "image" ? this.$t("请上传") : this.$tt("请输入");
      let list = [{ required: required, message: (pleaseInput + ` ` + (this.label || "")), trigger: "blur" }];
      if (this.rules) {
        list = list.concat(this.rules);
      }
      return list;
    },
    columnsLabel() {
      let finds = this.columns.filter(c => this.columnsKeyFun(c) === this.innerValue);
      if (finds && finds.length) {
        return this.columnsLabelFun(finds[0]);
      }
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    loading(newVal) {
      this.loadingInner = newVal;
    },
    innerValue: {
      handler(newVal, oldVal) {
        this.$emit("input", newVal);
        if (newVal !== oldVal) {
          this.$emit("change", newVal, oldVal);
        }
      },
      deep: true
    }
  },
  created() {
    this.loadingInner = this.loading;
    this.innerValue = this.value;
    // console.log("this.rulesInner", this.rulesInner);
  },
  methods: {
    formatter_number(value) {
      // 过滤输入的数字
      return value.replace(/\d/g, "");
    },
    clickUpload(field) {
    },
    keyup(field) {
      console.log("keyup");
    },
    onConfirm(obj) {
      console.log("onConfirm", obj);
      this.innerValue = this.columnsKeyFun(obj);
      this.showPicker = false;
      this.$emit("confirm", this.innerValue);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .van-field__body {
    justify-content: center;
  }

  .van-uploader__upload {
    margin: initial;
    //width: 100%;
    //height: auto;
  }

  .van-field__control {
    //justify-content: center;
  }

  .imgCenter {
    margin: auto;
  }

  //.van-uploader__preview-image{
  //  width: initial;
  //  height: initial;
  //}
}
</style>
